import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  StyledTextEditorCustomActionButton,
  StyledTextEditorToolbarFormatGroup
} from '../styled/details/stylesDetails';
import { batch, connect } from 'react-redux';
import {
  Button,
  Icon,
  Popover,
  PopoverArrow,
  PopoverBody,
  PopoverCloseButton,
  PopoverContent,
  PopoverTrigger
} from '@chakra-ui/react';
import {
  updateLayerPayload,
  wsAddLayer,
  wsAddPage,
  wsCloneLayers,
  wsClonePage,
  wsDeleteLayers,
  wsDeletePage,
  wsGroup,
  wsSaveAsTemplate,
  wsUnGroup,
  wsUpdatePage
} from '../../_actions/webSocketAction';
import { setActiveLayer, setActivePage, setCrop, setVideoPlayingStatus } from '../../_actions/textToolbarActions';
import {
  closeAdvancedSettings,
  openAdvancedSettings,
  openSlider,
  resetSliders,
  setOrUpdateStyles
} from '../../_actions/sidebarSliderActions';
import { TldrAction, TldrCustomIconAction } from '../common/statelessView';
import {
  ADVANCED_ANIMATION_PANEL,
  ADVANCED_EDITOR_EDIT,
  ADVANCED_EDITOR_EFFECTS,
  ADVANCED_EDITOR_PANEL,
  comboKey1,
  ELEMENTS_SLIDER_PANEL,
  FABRIC_SVG_ELEMENT,
  GIPHY_SLIDER_PANEL,
  IMAGES_SLIDER_PANEL,
  VIDEO_SLIDER_PANEL
} from './constants';
import { REPLACE_META, UPDATE_BKG } from '../../_actions/types';
import axios from 'axios';
import { wsStatusMessage } from '../../_middleware/middleware';
import { defaultBodyTextItem, INTERACTION_SELECTION } from '../canvas/constants/defaults';
import IconCommonActions from './layerActions/IconCommonActions';
import SlideCommonActions from './layerActions/SlideCommonActions';
import { analyticsTrackEvent, calculateIconColors, checkArtboardLimit } from '../../_utils/common';
import TldrCreateComponent from '../common/TldrCreateComponent';
import QuickCommonLayerActions from './layerActions/QuickCommonLayerActions';
import { ReactComponent as IconMotion } from '../../assets/icons/motion.svg';
import { ReactComponent as IconReplace } from '../../assets/icons/replace.svg';

import { primary, white } from '../styled/variable';
import {
  FaAdjust,
  FaChevronDown,
  FaChevronUp,
  FaCopy,
  FaFileDownload,
  FaFillDrip,
  FaImage,
  FaLayerGroup,
  FaMagic,
  FaObjectGroup,
  FaObjectUngroup,
  FaPalette,
  FaPause,
  FaPlus,
  FaShapes,
  FaStop,
  FaTrash,
  FaUnlock
} from 'react-icons/fa';
import { withTranslation } from 'react-i18next';
import TLDRColorPicker from '../common/tldrColorPicker/TLDRColorPicker';

class StudioCommonActions extends Component {
  signal = axios.CancelToken.source();

  constructor(props) {
    super(props);
    this.state = {
      fillColor: "transparent",
      showConfirmation: false,
      showSlidebackgroundActionsOverlay: false,
      showAlignActionsOverlay: false,
      showFlipActionsOverlay: false,
      showArrangeActionsOverlay: false,
    };
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    const { editor, pagestore } = nextProps;

    if (!pagestore.pageIds) {
      return null;
    }
    const { activeElement } = editor;

    if (activeElement) {
      let currentElementStyle = activeElement.format || {};

      if (currentElementStyle.backgroundColor !== prevState.fillColor) {
        return {
          ...prevState,
          fillColor: currentElementStyle.backgroundColor || "transparent",
        };
      }
      return null;
    }

    let currentPagePayload = pagestore.pages[editor.activePage.id];
    if (!currentPagePayload) {
      return null;
    }
    let currentPageStyle = currentPagePayload.payload || {};

    if (currentPageStyle.backgroundColor !== prevState.fillColor) {
      return {
        ...prevState,
        fillColor: currentPageStyle.backgroundColor || "transparent",
      };
    }

    return null;
  }

  delete = () => {
    const { activePage, activeElement, activeSelection } = this.props.editor;
    batch(() => {
      // Delete current page
      if (activeSelection.mime === "selection") {
        // Delete selected layer
        this.props.wsDeleteLayers(
          activeSelection.selectedElements,
          activePage.id
        );
      } else if (activePage.isSelected) {
        let totalPages = this.props.pagestore.pageIds.length;
        this.props.wsDeletePage(activePage.id);
        if (totalPages === 1) {
          this.props.closeAdvancedSettings();
        }
      } else {
        // Delete selected layer
        if (activeElement.id) {
          this.props.wsDeleteLayers([activeElement.id], activePage.id);
        }

        // If video get deleted
        if (activeElement.mime === "video") {
          this.props.canvasRef.handler.stopRequestAnimFrame();
        }
      }
      this.props.setActiveLayer(null, null, null, null);
      this.props.resetSliders();
    });
  };

  lock = () => {
    this.props.canvasRef.handler.lockLayer();
  };

  clone = () => {
    const { activePage, activeElement, activeSelection } = this.props.editor;
    const { pagestore, subscription } = this.props;

    if (activeSelection.mime === "selection") {
      // close selected layer
      this.props.wsCloneLayers(activeSelection.selectedElements, activePage.id);
    } else if (activePage.isSelected) {
      // Clone selected page
      const isAvailable = checkArtboardLimit(pagestore, subscription);
      if (isAvailable) this.props.wsClonePage(activePage.id);
    } else {
      // Clone selected/active layer
      this.props.wsCloneLayers([activeElement.id], activePage.id);
    }
  };

  fillElementColor = (hex) => {
    this.props.canvasRef.handler.objectHandler.backgroundColor(hex);
  };


  getCurrentActivePage = () => {
    const { editor, pagestore } = this.props;
    const { pages } = pagestore;
    return pages[editor.activePage.id];
  };

  onChangeCompleteFillColorHandler = (hex) => {
    if (this.state.fillColor === hex) return;

    this.setState({ fillColor: hex }, () => {
      this.fillElementColor(hex);
    });
  };

  replace = (action, userAction) => {
    let destination;
    if (!action) {
      // This is coming from slide
      this.props.setOrUpdateStyles(UPDATE_BKG, IMAGES_SLIDER_PANEL);
      return;
    }
    if (action === "image") {
      destination = IMAGES_SLIDER_PANEL;
    } else if (action === "video") {
      destination = VIDEO_SLIDER_PANEL;
    } else if (action === "giphy") {
      destination = GIPHY_SLIDER_PANEL;
    }
    this.props.setOrUpdateStyles(userAction, destination);
  };

  updatePage = (url, style) => {
    const pageId = this.props.editor.activePage.id;

    var message = {
      page: pageId,
      payload: {
        wallpaper: {
          mime: "image",
          url: url,
          filters: style && style.filters ? style.filters : {},
          opacity: style && style.opacity ? style.opacity : 1,
        },
      },
    };
    this.props.wsUpdatePage(message);
  };

  onPauseClick = () => {
    const { canvasRef } = this.props;
    const video = canvasRef.handler.canvas.getActiveObject().element;

    canvasRef.handler.stopRequestAnimFrame();
    video.pause();
    this.props.setVideoPlayingStatus(false);
  };

  showFiltersPanel = () => {
    this.props.openAdvancedSettings(
      ADVANCED_EDITOR_PANEL,
      ADVANCED_EDITOR_EFFECTS
    );
    analyticsTrackEvent("openEffectPanel");
  };

  export = () => {
    this.props.canvasRef.handler.saveImage();
  };

  showMotionsPanel = () => {
    this.props.openAdvancedSettings(
      ADVANCED_ANIMATION_PANEL,
      ADVANCED_EDITOR_EDIT
    );
  };

  render() {
    const { editor, location, canvasRef, brandKit, t, isMobileView } = this.props;
    const { activePage, activeElement, activeSelection } = editor;
    const { palette } =
      brandKit.brandkitPayload.length > 0 && brandKit.brandkitPayload[0];
    let colorElement = [];

    palette &&
      palette.length > 0 &&
      palette[0].colors.map((color) => {
        return colorElement.push(color.rgb);
      });

    if (activeElement.mime === "video" && activeElement.isVideoPlaying) {
      return (
        <>
          <StyledTextEditorToolbarFormatGroup>
            <TldrAction
              action={{}}
              icon={<FaPause />}
              title={t("pause")}
              userAction={{}}
              callback={this.onPauseClick}
            />

            <TldrAction
              action={{}}
              icon={<FaStop />}
              title={t("stop")}
              callback={this.onStopClick}
              disabled={!activeElement?.isVideoPlaying}
            />
          </StyledTextEditorToolbarFormatGroup>
        </>
      );
    }

    const { fillColor, showArrangeActionsOverlay } = this.state;

    const isGroupingEnabled = activeSelection.mime === "selection";
    const isUngroupingEnabled = activeElement.mime === "group";

    let iconPrefix = this.getElementTypeBasedOnMimeType(
      activeElement.mime ? activeElement.mime : activeSelection.mime
    );
    let noOfIconColors = calculateIconColors(
      activeElement ? activeElement : activeSelection
    );

    return (
      <>
        {!activeSelection.mime &&
          canvasRef?.handler?.interactionMode === INTERACTION_SELECTION && (
            <StyledTextEditorToolbarFormatGroup>
              <TldrAction
                action="add"
                icon={<FaPlus />}
                title={`${t("add")} ${iconPrefix}`}
                callback={this.add}
              />
            </StyledTextEditorToolbarFormatGroup>
          )}

        {location === "sidebar" && activeElement.mime && (
          <StyledTextEditorToolbarFormatGroup>
            <TldrAction
              action="save"
              icon={<FaShapes />}
              title={t("create_component_modal.modal_title_save", {
                ns: "studio",
              })}
              callback={this.createComponent}
            />
          </StyledTextEditorToolbarFormatGroup>
        )}

        {!activeSelection.mime &&
          canvasRef?.handler?.interactionMode === INTERACTION_SELECTION &&
          !isMobileView && <div className="tldr-vl" />}
        <StyledTextEditorToolbarFormatGroup>
          {canvasRef?.handler?.interactionMode === INTERACTION_SELECTION && (
            <>
              <TldrAction
                action="delete"
                icon={<FaTrash />}
                title={`${t("delete")} ${iconPrefix}`}
                shortcutKeys={["Del"]}
                callback={this.delete}
              />
              <TldrAction
                action="clone"
                icon={<FaCopy />}
                title={`${t("clone")} ${iconPrefix}`}
                callback={this.clone}
                shortcutKeys={[comboKey1, "D"]}
              />
            </>
          )}

          {location === "sidebar" && (
            <>
              <TldrCustomIconAction
                title={t("animate")}
                action={activeElement.mime}
                icon={<IconMotion fill={white} />}
                callback={this.showMotionsPanel}
              />

              {activeElement.mime && (
                <>
                  <TldrAction
                    action="lock"
                    icon={<FaUnlock />}
                    title={`${t("lock")} ${iconPrefix} ${t("layer")}`}
                    callback={this.lock}
                    shortcutKeys={[comboKey1, "Shift", "L"]}
                  />

                  {activeElement.mime !== "video" &&
                    <TldrAction
                      action="download"
                      icon={<FaFileDownload />}
                      title={`${t("export")} ${iconPrefix} ${t("layer")}`}
                      callback={this.export}
                    />
                  }
                </>
              )}
            </>
          )}

          {(isGroupingEnabled || isUngroupingEnabled) && (
            <TldrAction
              action={
                isGroupingEnabled
                  ? "group"
                  : isUngroupingEnabled
                  ? "ungroup"
                  : ""
              }
              icon={
                isGroupingEnabled ? (
                  <FaObjectGroup />
                ) : isUngroupingEnabled ? (
                  <FaObjectUngroup />
                ) : (
                  "none"
                )
              }
              title={`${
                isGroupingEnabled
                  ? t("group")
                  : isUngroupingEnabled
                  ? t("ungroup")
                  : ""
              } Elements`}
              disabled={!(isGroupingEnabled || isUngroupingEnabled)}
              hidden={!(isGroupingEnabled || isUngroupingEnabled)}
              callback={this.group}
              shortcutKeys={
                isGroupingEnabled
                  ? [comboKey1, "G"]
                  : isUngroupingEnabled
                  ? [comboKey1, "Shift", "G"]
                  : [""]
              }
            />
          )}
        </StyledTextEditorToolbarFormatGroup>

        {activeSelection.mime === "selection" && (
          <>
            {!isMobileView && <div className="tldr-vl" />}

            <Popover
              isLazy
              placement={isMobileView ? "top" : "bottom"}
              onOpen={() => this.setState({ showArrangeActionsOverlay: true })}
              onClose={() =>
                this.setState({ showArrangeActionsOverlay: false })
              }
            >
              <PopoverTrigger>
                <Button variant="unstyled" size="sm" mr={0} ml={0}  display="inherit">
                  <Icon
                    as={FaLayerGroup}
                    w={"1.3em"}
                    h={"1.3em"}
                    color={showArrangeActionsOverlay && primary}
                  />
                  &nbsp;
                  {showArrangeActionsOverlay ? (
                    <FaChevronUp color={showArrangeActionsOverlay && primary} />
                  ) : (
                    <FaChevronDown />
                  )}
                </Button>
              </PopoverTrigger>
              <PopoverContent width={"100%"}>
                <PopoverArrow />
                <PopoverBody>
                  <QuickCommonLayerActions
                    canvasRef={canvasRef}
                    isPositionSidebar={false}
                    showOrderOptions={false}
                    showFlipOptions={false}
                  />
                </PopoverBody>
              </PopoverContent>
            </Popover>
          </>
        )}

        {this.props.children}

        {activeElement.mime === "text" && location !== "sidebar" ? (
          <>
            <TLDRColorPicker
              showIcon
              icon={FaFillDrip}
              title={t('bg_color')}
              color={fillColor}
              action={"background_color"}
              callback={(action, hex) => this.onChangeCompleteFillColorHandler(hex)}
              showBrandkitPaletteColors={brandKit.brandkitPayload.length > 0}
              canvas={canvasRef.canvas}
              display={isMobileView ? "none" : ""}
              showColorInput={false}
            />
            {!isMobileView && <div className="tldr-vl" />}
          </>
        ) : activeElement.mime === "shape" ? (
          <>
            {location !== "sidebar" &&
              (activeElement.format.type === FABRIC_SVG_ELEMENT &&
              noOfIconColors <= 0 ? null : (
                <>
                  {!isMobileView && <div className="tldr-vl" />}
                  <StyledTextEditorToolbarFormatGroup>
                    <Popover
                      isLazy
                      placement={isMobileView ? "top" : "bottom"}
                    >
                      <PopoverTrigger>
                        <StyledTextEditorCustomActionButton>
                          <FaPalette />
                        </StyledTextEditorCustomActionButton>
                      </PopoverTrigger>
                      <PopoverContent width={"100%"}>
                        <PopoverArrow />
                        <PopoverCloseButton />
                        <PopoverBody>
                          <IconCommonActions
                            bottom={isMobileView ? "0" : ""}
                            right={isMobileView ? "0" : ""}
                            canvasRef={canvasRef}
                          />
                        </PopoverBody>
                      </PopoverContent>
                    </Popover>
                  </StyledTextEditorToolbarFormatGroup>
                  {!isMobileView && <div className="tldr-vl" />}
                </>
              ))}
          </>
        ) : activeElement.mime === "video" ||
          activeElement.mime === "giphy" ||
          activeElement.mime === "image" ? (
          <>
            <StyledTextEditorToolbarFormatGroup>
              <TldrCustomIconAction
                className="active"
                action={activeElement.mime}
                icon={<IconReplace fill={white} />}
                title={
                  activeElement.mime
                    ? `${"replace"} ${activeElement.mime}`
                    : t("update_bg")
                }
                userAction={REPLACE_META}
                callback={this.replace}
              />
            </StyledTextEditorToolbarFormatGroup>
          </>
        ) : activePage.isSelected &&
          location !== "sidebar" &&
          !activeSelection.mime &&
          canvasRef?.handler?.interactionMode === "selection" ? (
          <>
            <Popover
              placement={isMobileView ? "top" : "bottom"}
              onOpen={() =>
                this.setState({ showSlidebackgroundActionsOverlay: true })
              }
              onClose={() =>
                this.setState({ showSlidebackgroundActionsOverlay: false })
              }
            >
              <PopoverTrigger>
                <Button variant="unstyled" size="sm">
                  {canvasRef.handler?.workarea.backgroundColor === null &&
                  canvasRef.handler?.workarea?.fill?.type !== "linear" ? (
                    <Icon
                      as={FaImage}
                      color={"white"}
                      w={"1.3em"}
                      h={"1.3em"}
                    />
                  ) : canvasRef.handler?.workarea.backgroundColor === null &&
                    canvasRef.handler?.workarea?.fill?.type === "linear" ? (
                    <Icon
                      as={FaAdjust}
                      color={fillColor === "transparent" ? "white" : fillColor}
                      w={"1.3em"}
                      h={"1.3em"}
                    />
                  ) : (
                    <Icon
                      as={FaFillDrip}
                      color={fillColor === "transparent" ? "white" : fillColor}
                      w={"1.3em"}
                      h={"1.3em"}
                    />
                  )}
                  {this.state.showSlidebackgroundActionsOverlay ? (
                    <FaChevronUp color={primary} style={{display:"inline-block"}}/>
                  ) : (
                    <FaChevronDown  style={{display:"inline-block"}}/>
                  )}
                </Button>
              </PopoverTrigger>
              <PopoverContent width={"100%"}>
                <PopoverArrow />
                <PopoverBody>
                  {this.state.showSlidebackgroundActionsOverlay ? (
                    <SlideCommonActions
                      canvasRef={canvasRef}
                      right={-60}
                      width={250}
                      pickerTop={isMobileView ? "auto" : ""}
                      pickerBottom={isMobileView ? "36" : ""}
                      pickerZIndex={isMobileView ? 1 : ""}
                      isPositionSidebar={false}
                      showGradientModal={() =>
                        this.setState(
                          {
                            showSlidebackgroundActionsOverlay: false,
                            gradientEffectsModal: true,
                          },
                          () => {
                            this.props.openAdvancedSettings();
                            analyticsTrackEvent("applyGradient");
                          }
                        )
                      }
                    />
                  ) : (
                    <></>
                  )}
                </PopoverBody>
              </PopoverContent>
            </Popover>
            {!isMobileView && <div className="tldr-vl" />}
          </>
        ) : (
          <></>
        )}

        {activeElement.mime === "image" || activeElement.mime === "video" ? (
          <>
            <StyledTextEditorToolbarFormatGroup>
              {location !== "sidebar" && (
                <TldrAction
                  action={activeElement.mime}
                  icon={<FaMagic />}
                  title={t("apply_filters")}
                  callback={this.showFiltersPanel}
                />
              )}
            </StyledTextEditorToolbarFormatGroup>
            {/* <div className="tldr-vl" /> */}
          </>
        ) : (
          <></>
        )}

        <TldrCreateComponent
          canvasRef={this.props.canvasRef}
          show={this.state.showConfirmation}
          onHide={() => {
            this.setState({
              ...this.state,
              showConfirmation: false,
            });
          }}
        />
      </>
    );
  }

  componentWillUnmount() {
    this.signal.cancel("The user aborted a request.");
  }

  onStopClick = () => {
    const { canvasRef } = this.props;
    const target = canvasRef.handler.canvas.getActiveObject();
    if (!target) {
      return;
    }

    target.stop();
    canvasRef.handler.stopRequestAnimFrame();
    this.props.setVideoPlayingStatus(false);
  };

  add = () => {
    const { editor, story, pagestore, subscription } = this.props;
    // Add New Page
    if (editor.activePage.isSelected) {
      const isAvailable = checkArtboardLimit(pagestore, subscription);
      if (isAvailable) this.props.wsAddPage();
      return;
    }
    if (editor.activeElement.mime === "text") {
      let minSize = Math.min(
        story.payload.image_width,
        story.payload.image_height
      );
      defaultBodyTextItem.payload.fontSize = minSize * 0.05;
      this.props.wsAddLayer(
        this.props.editor.activePage.id,
        defaultBodyTextItem
      );
    } else if (editor.activeElement.mime === "image") {
      this.props.openSlider(IMAGES_SLIDER_PANEL);
    } else if (editor.activeElement.mime === "giphy") {
      this.props.openSlider(GIPHY_SLIDER_PANEL);
    } else if (editor.activeElement.mime === "shape") {
      this.props.openSlider(ELEMENTS_SLIDER_PANEL);
    } else if (editor.activeElement.mime === "video") {
      this.props.openSlider(VIDEO_SLIDER_PANEL);
    }
  };

  createComponent = () => {
    this.setState({
      showConfirmation: true,
    });
  };

  group = (action) => {
    const { canvasRef } = this.props;
    let activeObj = canvasRef.handler.canvas.getActiveObject();
    if (!activeObj) {
      return;
    }
    switch (action) {
      case "group":
        //this.props.wsGroup(activePage.id, activeSelection.selectedElements)
        canvasRef.handler.toGroup();
        break;
      case "ungroup":
        canvasRef.handler.toActiveSelection();
        break;
      default:
        return;
    }
  };

  getElementTypeBasedOnMimeType = (mime) => {
    switch (mime) {
      case "text":
        return "Text";
      case "image":
        return "Image";
      case "shape":
        return "Shape";
      case "selection":
        return "Selection";
      case "group":
        return "Group";
      case "giphy":
        return "giphy";
      case "video":
        return "Video";
      default:
        return "Artboard";
    }
  };

  advancedSettings = (selectedTab) => {
    this.props.openAdvancedSettings(ADVANCED_EDITOR_PANEL, selectedTab);
  };
}

StudioCommonActions.propTypes = {
  pagestore: PropTypes.object.isRequired,
  layerstore: PropTypes.object.isRequired,
  editor: PropTypes.object.isRequired,
  story: PropTypes.object.isRequired,
  wsCloneLayers: PropTypes.func.isRequired,
  wsDeleteLayers: PropTypes.func.isRequired,
  wsAddLayer: PropTypes.func.isRequired,
  auth: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  editor: state.editor,
  pagestore: state.pagestore,
  layerstore: state.layerstore,
  story: state.story,
  brandKit: state.brandKit,
  auth: state.auth,
  isMobileView: state.app.isMobileView,
  subscription: state.subscription,
});

const mapDispatchToProps = (dispatch) => ({
  wsAddLayer: (pageId, payload) => dispatch(wsAddLayer(pageId, payload)),
  wsDeletePage: (pageId) => dispatch(wsDeletePage(pageId)),
  wsClonePage: (pageId) => dispatch(wsClonePage(pageId)),
  wsDeleteLayers: (layerIds, pageId) =>
    dispatch(wsDeleteLayers(layerIds, pageId)),
  wsCloneLayers: (layerIds, pageId) =>
    dispatch(wsCloneLayers(layerIds, pageId)),
  wsAddPage: () => dispatch(wsAddPage()),
  setActiveLayer: (elementId, elementType, layerId, elementParentId) =>
    dispatch(setActiveLayer(elementId, elementType, layerId, elementParentId)),
  setActivePage: (pageId, pageIndex, isSelected) =>
    dispatch(setActivePage(pageId, pageIndex, isSelected)),
  openAdvancedSettings: (panelName, selectedTab) =>
    dispatch(openAdvancedSettings(panelName, selectedTab)),
  wsUpdatePage: (payload) => dispatch(wsUpdatePage(payload)),
  wsSaveAsTemplate: (pageId) => dispatch(wsSaveAsTemplate(pageId)),
  resetSliders: () => dispatch(resetSliders()),
  setOrUpdateStyles: (action, destination) =>
    dispatch(setOrUpdateStyles(action, destination)),
  setCrop: (isEnable) => dispatch(setCrop(isEnable)),
  updateLayerPayload: (payload) => dispatch(updateLayerPayload(payload)),
  wsStatusMessage: (message) => dispatch(wsStatusMessage(message)),
  openSlider: (panel) => dispatch(openSlider(panel)),
  wsGroup: (pageId, layers) => dispatch(wsGroup(pageId, layers)),
  wsUnGroup: (layerId) => dispatch(wsUnGroup(layerId)),
  setVideoPlayingStatus: (isPlaying) =>
    dispatch(setVideoPlayingStatus(isPlaying)),
  closeAdvancedSettings: () => dispatch(closeAdvancedSettings()),
});

export default withTranslation(["common", "studio"])(
  connect(mapStateToProps, mapDispatchToProps)(StudioCommonActions)
);
